@if (dataVisible$ | async) {
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col col-1">
        <p>Aftrekbare giften</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button (click)="this.showDialog()"
                             [disabled]="(formGroup.controls.totaalGiftenaftrek.value ?? 0) === 0"
                             class="custom-input-150"
                             icon="eye"
                             type="secondary">Specificatie
        </snelstart-ui-button>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="totaalGiftenaftrek"
          id="totaalGiftenaftrek"
          placeholder="-"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-2"></div>
    </div>
  </form>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg" title="Specificatie giften">
    <snelstart-ui-dialog-body>
      <form [formGroup]="formGroup">
        @if ((formGroup.controls.gewoneGiften.value ?? 0) > 0) {
          <div class="row">
            <div class="col col-1">
              <p>Gewone giften</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="gewoneGiften"
                id="gewoneGiften"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-2"></div>
          </div>
        }
        @if ((formGroup.controls.gewoneGiftenCultureel.value ?? 0) > 0) {
          <div class="row">
            <div class="col col-1">
              <p>Gewone giften cultureel</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="gewoneGiftenCultureel"
                id="gewoneGiftenCultureel"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-2"></div>
          </div>
        }
        @if ((formGroup.controls.verhogingGewoneCultureleGiften.value ?? 0) > 0) {
          <div class="row">
            <p>Verhoging culturele gewone giften</p>
            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="verhogingGewoneCultureleGiften"
                id="verhogingGewoneCultureleGiften"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-2"></div>
          </div>
        }
        @if ((formGroup.controls.drempelGiften.value ?? 0) > 0) {
          <div class="row">
            <div class="col col-1">
              <p>Af: Drempel gewone giften</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="drempelGiften"
                id="drempelGiften"
                prefix="€ - "
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-2"></div>
          </div>
        }
        <div class="row">
          <div class="col col-1">
            <p>Aftrekbare gewone giften</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="aftrekbareGewoneGiften"
              id="aftrekbareGewoneGiften"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-2"></div>
        </div>
        @if ((formGroup.controls.periodiekeGiften.value ?? 0) > 0) {
          <div class="row">
            <div class="col col-1">
              <p>Periodieke giften</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="periodiekeGiften"
                id="periodiekeGiften"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-2"></div>
          </div>
        }
        @if ((formGroup.controls.periodiekeGiftenCultureel.value ?? 0) > 0) {
          <div class="row">
            <div class="col col-1">
              <p>Periodieke giften cultureel</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="periodiekeGiftenCultureel"
                id="periodiekeGiftenCultureel"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-2"></div>
          </div>
        }
        @if ((formGroup.controls.verhogingPeriodiekeCultureleGiften.value ?? 0) > 0) {
          <div class="row">
            <div class="col col-1">
              <p>Verhoging periodieke giften cultureel</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="verhogingPeriodiekeCultureleGiften"
                id="verhogingPeriodiekeCultureleGiften"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-2"></div>
          </div>
        }
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button icon="check" id="save" type="primary">
        Akkoord
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}


